import { BaseDto } from '../../core';
import { PAYMENT_METHOD } from '../../shared';

export class PaypalCaptureDto extends BaseDto<PaypalCaptureDto> {
  paymentMethod = PAYMENT_METHOD.PAYPAL;
  orderNumber: number;
  paypalOrderId: string;
  paypalAuthorizationId: string;
}
